import { render, staticRenderFns } from "./CarImage.vue?vue&type=template&id=667b9ab6&"
import script from "./CarImage.vue?vue&type=script&lang=js&"
export * from "./CarImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports